const excludedFieldTypes = ['textblock', 'link'];

const getFlattenProp = propName => (flattenValue, object) => [
  ...flattenValue,
  ...object[propName]
];

const replaceEnvironmentValue = value => {
  // eslint-disable-next-line
  if (value.includes('${edulink}')) {
    const url =
      process.env.NODE_ENV === `development`
        ? process.env.REACT_APP_EDULINK_URL
        : '';
    // eslint-disable-next-line
    return value.replace('${edulink}', url);
  }
  return value;
};

//get all field ids from schema into a flat array
export const getFieldsIdsByPage = form => {
  if (form.pages) {
    const arrayOfGroupArraysByPage = form.pages.reduce((acc, page) => {
      const groupsByPage = [page].reduce(getFlattenProp('groups'), []);

      acc.push(groupsByPage);
      return acc;
    }, []);

    const arrayOfFieldsArraysByPage = arrayOfGroupArraysByPage.reduce(
      (acc, page) => {
        const fieldsByPage = page.reduce(getFlattenProp('fields'), []);

        acc.push(fieldsByPage);
        return acc;
      },
      []
    );

    const arrayOfOnlyInputFieldsObjectsByPage = arrayOfFieldsArraysByPage.reduce(
      (acc, fields) => {
        const result = [];

        fields.forEach(field => {
          if (!excludedFieldTypes.includes(field.type)) {
            const allFields = ['subfields', 'flex'].includes(field.type)
              ? field.fields
              : [field];
            result.push(...allFields);
          }
        });

        acc.push(result);

        return acc;
      },
      []
    );

    return arrayOfOnlyInputFieldsObjectsByPage.reduce((acc, fields) => {
      const result = [];

      fields.forEach(field => {
        result.push(field.id);
      });

      acc.push(result);
      return acc;
    }, []);
  }

  return [];
};

export const getAsyncGroups = form => {
  //array of async objects from form
  return form.pages.reduce(
    (acc, page) => {
      const groups = page.groups || [];
      groups.forEach(group => {
        if (!group.validationAction) {
          return;
        }
        //create object of all async fields for faster access
        group.fields.forEach(field => {
          acc.asyncFields[field.id] = field.id;
        });
        //groups that should be validated together
        acc.asyncGroups.push({
          action: replaceEnvironmentValue(group.validationAction),
          fields: group.fields.map(field => field.id),
          errorMessage: group.validationErrorMessage
        });
      });

      return acc;
    },
    { asyncFields: {}, asyncGroups: [] }
  );
};
